/* eslint-disable react-hooks/exhaustive-deps */
import CallToActionButton from 'components/Buttons/CallToActionOutlinedButton.index'
// import { enviarClickCarregarMais } from 'hooks/useGCJAnalytics'
import { FilterContext } from 'providers/Filter'
import { FilterDataContext } from 'providers/FilterData'
import React, { useContext } from 'react'
import { get } from 'lodash'

const SearchMoreBox: React.FC<any> = (props) => {
  const clientSlug = process.env.NEXT_PUBLIC_WEBAPP_CLIENT_SLUG

  const filterContext = useContext(FilterContext)
  const filterDataContext = useContext(FilterDataContext)

  const isLoading = filterDataContext.loading
  const isDisabled = isLoading || filterDataContext.totalItems <= filterContext.filters.pageStart
  const templatePolicyId = props?.slotTemplateCode
  const templateFilters = filterContext.filters[templatePolicyId] || {}
  const templateData = filterDataContext.collections[templatePolicyId] || {}
  const templateTotalItems = templateData.totalItems || 0
  const templatePageStart = templateFilters.pageStart || 0
  const templatePageRows = templateFilters.pageRows || 1
  const paginationLimit = templatePageStart + templatePageRows >= templateTotalItems

  const handleMore: any = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const searchPageMatcher = new RegExp('\\/pesquisa')
    const tagPageMatcher = new RegExp('\\/tag')
    const urlIsSearchPage = searchPageMatcher.test(window.location.href)
    const urlIsTagPage = tagPageMatcher.test(window.location.href)
    const searchTag = urlIsTagPage && urlParams.get('tag') || ''
    const searchText = urlIsSearchPage && urlParams.get('term') || ''

    //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
    // quando confirmado a migração, remover.
    // if(!window.AnalyticsGJC.loadMoreCurrentPage) {
    //   window.AnalyticsGJC.loadMoreCurrentPage = 0;
    // }

    const contentId = get(props, 'id', '').replace('policy:', '');
    //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
    // quando confirmado a migração, remover.
    // enviarClickCarregarMais(contentId, ++window.AnalyticsGJC.loadMoreCurrentPage);

    filterContext.updateFilter(templatePolicyId, {
      departments: templateFilters.departments,
      pageRows: templateFilters.pageRows,
      pageStart: templatePageStart + templatePageRows
    })
    filterDataContext.loadSearchEngineData({
      dateStart: templateFilters.date ? new Date(new Date(templateFilters.date).setHours(0, 0, 0)).toISOString() : null,
      dateEnd: templateFilters.date ? new Date(new Date(templateFilters.date).setHours(23, 59, 59)).toISOString() : null,
      departments: templateFilters.departments,
      policyId: templatePolicyId,
      pageRows: templateFilters.pageRows,
      pageStart: templatePageStart + templatePageRows,
      searchTag: searchTag,
      searchText: searchText
    }, { isPaginated: true })
  }

  if (!templatePolicyId || paginationLimit === true) {
    return <></>
  }

  return (
    <CallToActionButton
      onClick={handleMore}
      id='carregar-mais-noticias'
      disabled={isDisabled}
      css={{
        button: {
          mb: '$4',
          width: '100%',
          '&:disabled': {
            borderColor: 'rgb(167, 167, 167)',
            backgroundColor: '$basicWhite',
          }
        },
        label: {
          color: isDisabled ? 'rgb(167, 167, 167)' : clientSlug == 'daqui' ? '$secondaryMain' : '$primaryMain'
        }
      }}
    >
      {isLoading ? 'CARREGANDO MAIS NOTÍCIAS...' : 'CARREGAR MAIS NOTÍCIAS'}
    </CallToActionButton>
  )
}

export default SearchMoreBox
